// extracted by mini-css-extract-plugin
module.exports = {"tdStyle":"tdStyle--gt8_n"};